// SMS segment / encoding utilities.
// Computes the number of SMS segments a message will use based on its actual
// content: GSM-7 (7-bit) or UCS-2 (Unicode 16-bit).

const GSM7_BASE = new Set([
  ..."@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
    "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà",
]);

// Extension table: each of these counts as 2 septets in GSM-7 encoding.
const GSM7_EXT = new Set([..."|^€{}[]~\\"]);

const GSM7_SINGLE = 160;
const GSM7_MULTI = 153;
const UCS2_SINGLE = 70;
const UCS2_MULTI = 67;

/**
 * Analyze an SMS message body.
 * @param {string} text
 * @returns {{ chars: number, segments: number, encoding: "gsm7" | "ucs2", perSegment: number }}
 */
export function smsInfo(text) {
  if (!text) return { chars: 0, segments: 0, encoding: "gsm7", perSegment: GSM7_SINGLE };

  let septets = 0;
  let unicode = false;

  // Iterate by Unicode code points so surrogate pairs count as one character
  for (const ch of text) {
    if (GSM7_BASE.has(ch)) septets += 1;
    else if (GSM7_EXT.has(ch)) septets += 2;
    else { unicode = true; break; }
  }

  if (unicode) {
    // UCS-2 counts UTF-16 code units; surrogate pairs use 2 units each.
    const units = text.length;
    if (units <= UCS2_SINGLE) return { chars: units, segments: 1, encoding: "ucs2", perSegment: UCS2_SINGLE };
    return { chars: units, segments: Math.ceil(units / UCS2_MULTI), encoding: "ucs2", perSegment: UCS2_MULTI };
  }

  if (septets <= GSM7_SINGLE) return { chars: septets, segments: 1, encoding: "gsm7", perSegment: GSM7_SINGLE };
  return { chars: septets, segments: Math.ceil(septets / GSM7_MULTI), encoding: "gsm7", perSegment: GSM7_MULTI };
}
